import { addDays, startOfDay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

const isNextDayDelivery = (deliveryDate) => {
  if (!deliveryDate) return false;

  try {
    const timeZone = 'Europe/London';
    const deliveryDay = startOfDay(
      utcToZonedTime(new Date(deliveryDate), timeZone),
    );
    const tomorrow = startOfDay(
      addDays(utcToZonedTime(new Date(), timeZone), 1),
    );

    return deliveryDay.getTime() === tomorrow.getTime();
  } catch {
    return false;
  }
};

export default isNextDayDelivery;
